import { PrintNonConsignmentListPage } from "@/features/print-non-consignment/pages/PrintNonConsignmentListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/print-non-consignment/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["print_label.view_non_consignment"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: PrintNonConsignmentListPage,
});
